import { useEffect } from 'react';
import { trackPageView } from '../utils/analytics';

/**
 * Custom hook to track page views
 * @param path The current path to track
 */
export const usePageTracking = (path: string) => {
  useEffect(() => {
    // Track page view when path changes
    trackPageView(path);
  }, [path]);
};

export default usePageTracking;